module.exports = __webpack_public_path__ + "media/images/cape_air-f156b766.png";